import { Button } from "@/components/custom/button.tsx";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { client } from "@/client";
import { useNavigate } from "@tanstack/react-router";

export default function Unauthorized() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const relatedAccounts = useQuery(
    client.users.getRelatedAccounts.asQueryOptions(),
  );
  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <div className="text-4xl">{t("unauthorized")}</div>
        <div className="text-xl text-muted-foreground">
          {t("youAreUnauthorized")}
          {(relatedAccounts?.data?.length ?? 0) > 1 && (
            <>
              <br />
              {t("trySwitchingToADifferentAccount")}
            </>
          )}
        </div>
      </div>
      <Button
        size="2xl"
        variant={"azure"}
        onClick={() => navigate({ to: "/dashboard" })}
      >
        {t("goBack")}
      </Button>
    </div>
  );
}
